/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
import type { BookPublicEventPaymentPayload } from './BookPublicEventPaymentPayload';
import type { DateTime } from './DateTime';
export type BookPublicEventPayload = {
    eventRuleId: number;
    eventCategoryId?: number;
    start: DateTime;
    end: DateTime;
    locationSelection?: BookPublicEventPayload.locationSelection;
    fingerprint: string;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber?: string;
    address?: Address;
    birthdate?: string;
    payment?: BookPublicEventPaymentPayload;
    publicBookingSiteId?: string;
};
export namespace BookPublicEventPayload {
    export enum locationSelection {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
}

